// @archigraph r8DljQiU
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { ErrorBoundary } from './components/ErrorBoundary';
import { useAuthStore } from './store/authStore';

import { LandingPage } from './pages/LandingPage';
import { DownloadPage } from './pages/DownloadPage';
import { SignupPage } from './pages/SignupPage';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { NotFoundPage } from './pages/NotFound';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { DocsPage } from './pages/DocsPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ViewerPage } from './pages/ViewerPage';

export function App() {
  const checkAuth = useAuthStore((state) => state.checkAuth);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            {/* @archigraph contains|ui.website|ui.website.landing|product (uuid: oPgyVz0Y) */}
            <Route path="/" element={<LandingPage />} />

            {/* @archigraph contains|ui.website|ui.website.download|product (uuid: 7qseDRed) */}
            <Route path="/download" element={<DownloadPage />} />

            {/* @archigraph contains|ui.website|ui.website.signup|product (uuid: IXnoTz4c) */}
            <Route path="/signup" element={<SignupPage />} />

            {/* @archigraph contains|ui.website|ui.website.login|product (uuid: eHS4iX7G) */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />

            {/* @archigraph contains|ui.website|ui.website.dashboard|product (uuid: c32W6R8d) */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />

            <Route path="/viewer" element={<ViewerPage />} />
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />

            {/* 404 fallback */}
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
